import { InjectionToken } from '@angular/core';
import { StoreConfig } from '@ngrx/store';

import { State } from './product-basket.reducer';

export const PBASKET_STORAGE_KEYS = new InjectionToken<keyof State>(
  'PBasketStorageKeys',
);
export const PBASKET_STORAGE_KEY = new InjectionToken<string[]>(
  'PBasketStorage',
);
export const PBASKET_CONFIG_TOKEN = new InjectionToken<StoreConfig<State>>(
  'PBasketConfigToken',
);
